const errorCode = {
  777: '前端不知道，找后端小哥哥',
  999: '服务器未知错误',
  10000: '认证失败',
  10020: '资源不存在',
  10030: '参数错误',
  10040: 'assessToken令牌失效',
  10050: 'assessToken令牌过期',
  10060: '字段重复',
  10070: '不可操作',
  10100: 'refreshToken异常',
}

export default errorCode
